export default "__VITE_ASSET__B14kqWLm__"